import getEmojiRegex from 'emoji-regex';

const emojiRegex = getEmojiRegex();

export function isOnlyEmojis(text: string) {
  if (!text) {
    return false;
  }

  const textWithoutEmojis = text.replace(emojiRegex, '').replace(/\s+/g, '');

  return textWithoutEmojis.length === 0;
}

export function matchOnlyEmojis(text: string): string[][] | null {
  if (!isOnlyEmojis(text)) {
    return null;
  }

  const emojis: string[] = [];
  let match: RegExpExecArray | null;

  while ((match = emojiRegex.exec(text)) !== null) {
    emojis.push(match[0]);
  }

  const emojiCodes = emojis.map((emoji) => {
    const codePoints: string[] = [];
    for (const char of emoji) {
      const codePoint = char.codePointAt(0);
      if (codePoint !== undefined) {
        codePoints.push(codePoint.toString(16));
      }
    }
    return codePoints;
  });

  return emojiCodes;
}

export function codesToEmoji(codes: string[]) {
  return codes
    .map((code) => {
      return String.fromCodePoint(parseInt(code, 16));
    })
    .join('');
}
